var React = require('react');

function CheckmarkdoneInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"submitted"),React.createElement("polyline",{"points":"464 128 240 384 144 288","style":{"fill":"none","stroke":"#FFFFFF","strokeLinecap":"square","strokeLinejoin":"miter","strokeWidth":"32px"},"key":1}),React.createElement("line",{"x1":"144","y1":"384","x2":"48","y2":"288","style":{"fill":"none","stroke":"#FFFFFF","strokeLinecap":"square","strokeLinejoin":"miter","strokeWidth":"32px"},"key":2}),React.createElement("line",{"x1":"368","y1":"128","x2":"232","y2":"284","style":{"fill":"none","stroke":"#FFFFFF","strokeLinecap":"square","strokeLinejoin":"miter","strokeWidth":"32px"},"key":3})]);
}

CheckmarkdoneInline.defaultProps = {"width":"40","height":"40","viewBox":"0 0 512 512"};

module.exports = CheckmarkdoneInline;

CheckmarkdoneInline.default = CheckmarkdoneInline;
